import logo from "../../assets/logo.png";

const Brand = () => {
	return (
		<div className="flex justify-center">
			<img
				className="w-48 md:w-72 h-auto"
				src={logo}
				alt="Power of Patients brand-img"
			/>
		</div>
	);
};

export default Brand;
